import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as companyRegionActions from "../../actions/companyRegionsActions";
import * as companyMunicipalityActions from "../../actions/companyMunicipalityActions";
import * as companyActions from "../../actions/companyActions";
import * as userActions from "../../actions/userActions";
import * as userAddressSearchActions from "../../actions/user/userAddressSearchActions";
import * as submitButtonActions from '../../actions/submit/submitButtonActions';
import UserProfileForm from "./UserProfileForm";
import CompanyInformationSelector from "../../reducers/company/CompanyInformationSelector";
import UserProfileParamsFormatter from "../../services/user/UserProfileParamsFormatter";
import {toastr} from 'react-redux-toastr';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import WithResolvedPromises from "../common/WithResolvedPromises";
import Placeholder from "../Placeholder";
import PlaceholderError from "../common/PlaceholderError";
import ChangeUserPasswordModal from "./ChangeUserPasswordModal";
import Resource from "../../services/Resource";
import {reset} from 'redux-form';

class UserProfileFormContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {isOpenChangePasswordModal: false};
        this.onSubmit = this.onSubmit.bind(this);
        this.actions = this.getRequiredActions();
        this.openChangePasswordModal = this.openChangePasswordModal.bind(this);
        this.closeChangePasswordModal = this.closeChangePasswordModal.bind(this);
        this.submitChangePassword = this.submitChangePassword.bind(this);
    }

    getRequiredActions() {
       return [
           this.props.actions.loadCompanyRegions(),
           this.props.actions.loadCompanyMunicipalities(),
       ];
    }

    onSubmit(formFields) {
        this.props.actions.showSubmitButtonSpinner();
        let params = UserProfileParamsFormatter.format(formFields);
        this.props.actions.updateUserProfile(params).then(()=>{
            this.props.actions.hideSubmitButtonSpinner();
            toastr.success(this.props.intl.formatMessage(messages.userProfileUpdated));
            this.redirect();
        }).catch(() =>
            this.props.actions.hideSubmitButtonSpinner());
    }

    redirect() {
        this.context.router.history.push('/user/profil')
    }

    componentDidMount() {
        this.props.actions.loadCompanyRegions();
        this.props.actions.loadCompanyMunicipalities();
    }

    openChangePasswordModal() {
        this.setState({isOpenChangePasswordModal: true});
    }

    closeChangePasswordModal() {
        this.setState({isOpenChangePasswordModal: false});
    }

    submitChangePassword(formInputValues) {
        Resource
            .put("api/privateV1/global-users/change-user-password", {
                currentPassword: formInputValues.oldPassword,
                newPassword: formInputValues.newPassword
            })
            .then(() => {
               toastr.success('Dit kodeord er nu skiftet');
               this.closeChangePasswordModal();
            })
            .catch((error) => {
                toastr.error(error.message);
            });
    }

    render() {
        return (
            <WithResolvedPromises preloaderComponent={Placeholder} promises={this.actions} errorComponent={PlaceholderError}>
                <div className="row">
                    <div className="col-12">
                        <div className="card m-b-20">
                            <div className="card-block">
                                <h1>{this.props.intl.formatMessage(messages.editUserProfile)}</h1>
                                <UserProfileForm
                                    initialValues={this.props.initialValues}
                                    enableReinitialize={true}
                                    keepDirtyOnReinitialize={true}
                                    actions={this.props.actions}
                                    regions={this.props.regions}
                                    municipalities={this.props.municipalities}
                                    addresses={this.props.addresses}
                                    openChangePasswordModal={this.openChangePasswordModal}
                                    onSubmit={this.onSubmit}
                                />
                                <ChangeUserPasswordModal
                                    isOpen={this.state.isOpenChangePasswordModal}
                                    openModal={this.openChangePasswordModal}
                                    closeModal={this.closeChangePasswordModal}
                                    onSubmit={this.submitChangePassword}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </WithResolvedPromises>
        )

    }
}

UserProfileFormContainer.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {

    let municipalities = Array.from(state.companyMunicipalities);

    if (state.userProfile.regionId !== '') {
        municipalities = CompanyInformationSelector.filterMunicipalitiesByRegion(
            state.companyMunicipalities,
            state.userProfile.regionId
        );
    }

    return {
        initialValues: state.userProfile,
        regions: CompanyInformationSelector.fillSelects(state.companyRegions, 'regions'),
        municipalities: CompanyInformationSelector.fillSelects(municipalities, 'municipalities'),
        addresses: CompanyInformationSelector.fillSelects(state.userAddressSearchResults, 'addresses')
    };
}

function mapDispatchToProps(dispatch) {
    let resetPasswordChangeForm = () => {
        dispatch(reset('changeUserPasswordModalForm'));
    };

    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                userActions,
                companyActions,
                companyRegionActions,
                userAddressSearchActions,
                companyMunicipalityActions,
                submitButtonActions
            ), dispatch
        )
    }

}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(UserProfileFormContainer));



// WEBPACK FOOTER //
// ./web/src/components/users/UserProfileFormContainer.jsx